import { Box, Checkbox, Typography } from "@mui/material";
import styles from "../../screens/Requirement/Requirement.module.css";
import { formatDate, formatTime } from "../../utils/const";
const CandidateCardForJobPost = ({
  name,
  job_title,
  experience,
  location,
  prefr_tax_team,
  created_date,
  res,
  toggleSelect,
  requirement
}) => {
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  return (
    <Box className={styles.candidateCard}>
      <Box>
        <Typography>
          <b>{name}</b>
        </Typography>
        <Typography>
          {job_title},Exp {experience} Years
        </Typography>
        <Typography> {location}</Typography>
        <Typography sx={{ marginBottom: "0 !important" }}>
          {prefr_tax_team}
        </Typography>
      </Box>
      <span>
        <Typography>
          {created_date !== undefined && formatDate(created_date)}{" "}
          {created_date !== undefined && formatTime(created_date)}{" "}
        </Typography>
        {/* <Typography sx={{ cursor: "pointer", textDecoration: "underline" }}>
          <b> View Job</b>
        </Typography> */}
        <Checkbox
          {...label}
          checked={requirement?.selected === true}
          onChange={() => toggleSelect(res?.id)}
        />
      </span>
    </Box>
  );
};

export default CandidateCardForJobPost;
